import React, { useCallback, useMemo, useState } from 'react';

import { Form, Layout, message } from 'antd'
import cn from 'classnames';
import Image from 'next/legacy/image'
import { useRouter, withRouter } from 'next/router';

import SafetTipModal from '@components/SafetTipModal';
import { verification } from '@widget/loginRegister/utils'

import { CustomerAPI } from '../../api/customer';
import CountrySelect from '../../components/CountrySelect'
import { Button, Input } from '../../components/Element';
import Navbar from '../../components/Navbar'
import ProgressBar from '../../components/ProgressBar'
import I18n from '../../utils/i18n';
import { isEmail } from '../../utils/validator';

import forgetPassStyles from '../../styles/modules/forgetPass.module.css';
import styles from './index.module.less'

const { Footer } = Layout;

const Index = (props) => {
  const { router: { query: { loginType } } } = props
  const [form] = Form.useForm();
  const router = useRouter();
  const [loading, setloading] = useState(false)
  const [validateStatus, setvalidateStatus] = useState('')
  const [errormsg, setErrormsg] = useState('')
  const [tipmsg, settipmsg] = useState('')
  const [forgetData, setforgetData] = useState({})
  const [visible, setvisible] = useState(false)

  const onFinish = useCallback(values => {
    setvisible(true)
  }, []);

  const onFinishNoCaptcha = useCallback((options) => {
    const { mobile, country, email } = form.getFieldsValue(['mobile', 'country', 'email'])

    const mobilenum = mobile ? `+${country.telephoneCode}${mobile}` : ''
    const forgetData = {
      mobile: encodeURIComponent(mobilenum),
      email: email || ''
      // isVerifyType: loginType
    }
    setforgetData(forgetData)
    CustomerAPI.sendVerifyCode({
      ...forgetData,
      type: '1',
      businessType: '1'
    }, options)
      .then((response) => {
        if (response.success) {
          sessionStorage.setItem('forgetData', JSON.stringify({ ...forgetData, isVerifyType: loginType }))
          setloading(true)
          message.success(I18n.t('forgetPass_step_two_success'));
          router.push('/forgetPass/verifyCode')
        } else {
          // 用户不存在情况
          if (response.msgKey === 'customer.verify.code.sent') {
            message.success(I18n.t('forgetPass_step_two_success'));
            setErrormsg(I18n.t('customer.verify.code.sent'))
            router.push('/forgetPass/verifyCode')
            return
          }
          if (response.msgKey === 'customer.exist.none') {
            setvalidateStatus('error')
            setErrormsg(I18n.t('forgetPass_step_two_errortip_one'))
            settipmsg('unregister')
            return
          }
          // setCountDown(false);
          message.error(I18n.t(response.msgKey));
        }
      })
      .catch((error) => {
        message.error(I18n.t('system.error'));
      });
  }, [props, router, forgetData])

  const helperDom = useMemo(() => {
    if (validateStatus === 'error' && tipmsg === 'unregister') {
      return (
        <div
        style={{ cursor: 'pointer' }}
        onClick={() => {
          router.replace({
            pathname: '/register'
          })
        }}
      >{errormsg}<span style={{ color: '#6F40EE' }}>{I18n.t('forgetPass_step_two_errortip_two')}</span>
        <Image
          alt=''
          src={require('@images/left.webp')}
          // layout="fixed"
          width={8}
          height={8}
        /></div>
      )
    }
    if (validateStatus === 'error' && tipmsg !== 'unregister') {
      return (
                <div
                  onClick={() => {
                  }}
                >{errormsg}</div>
      )
    }
    return ''
  }, [validateStatus, tipmsg, errormsg, router])

  const inputChange = (e) => {
    settipmsg('')
    const value = e.target.value
    if (!value && loginType === 'email') {
      setvalidateStatus('error')
      setErrormsg(I18n.t('forgetPass_step_one_email_pls'))
      return
    }
    if (!isEmail(value) && loginType === 'email') {
      setvalidateStatus('error')
      setErrormsg(I18n.t('forgetPass_step_one_email_error'))
      return
    }
    setvalidateStatus('')
  }

  const onOk = () => {
    setvisible(false)
    verification(onFinishNoCaptcha)
  }

  const onCancel = useCallback(() => {
    setvisible(false)
  }, [])

  return (
    <div className={forgetPassStyles.container}>
      <Navbar type='2'/>

      <div className={forgetPassStyles.main}>
        <p className={forgetPassStyles.title}>{I18n.t('forgetPass_step_one_forget')}</p>
        <p className={cn(forgetPassStyles.subTitle, 'DINPro')}>{I18n.t('forgetPass_step_one_tip')}</p>
        <div className={forgetPassStyles.stepline}>
          <ProgressBar
            step={1}
            stepTitle={[
              I18n.t('progressbar_onetep'),
              I18n.t('progressbar_twotep'),
              I18n.t('progressbar_threetep')
            ]}
          />
        </div>
        <Form form={form} noStyle onFinish={onFinish}>
          {
            loginType === 'mobile'
              ? (
              <div className={forgetPassStyles.stepOne}>
                <Form.Item
                name="country"
                whitespace={true}
                label=""
                initialValue={{ id: 'HK', telephoneCode: '852' }}
                className={styles.countryCode}
                >
                    <CountrySelect
                      showCountryCode={true}
                    />
                </Form.Item>
                <Form.Item
                  name="mobile"
                  label=""
                  validateStatus={validateStatus}
                  help={helperDom}
                  onChange={inputChange}
                  className={styles.phoneNumber}
                >
                    <Input placeholder={I18n.t('forgetPass_step_one_mobile_pls')}/>
                </Form.Item>
              </div>
                )
              : (
              <div >
                  <Form.Item
                    className={forgetPassStyles.stepOnemail}
                    name='email'
                    validateStatus={validateStatus}
                    help={helperDom}
                  >
                    <Input
                      style={{ width: '100%' }}
                      name='email'
                      placeholder={I18n.t('forgetPass_step_one_email_pls')}
                      onChange={inputChange}
                    />
                  </Form.Item>
            </div>
                )
          }
          {
            loginType === 'mobile'
              ? (
              <Form.Item
              noStyle
              shouldUpdate={(pre, cur) => (pre.mobile !== cur.mobile)}
            >
              {({ getFieldValue }) => {
                return (
                  <Button
                    disabled={!getFieldValue('mobile')?.trim()}
                    className={forgetPassStyles.stepOneButton}
                    type="primary"
                    htmlType="submit"
                  >{I18n.t('forgetPass_step_one_next')}</Button>
                );
              }}

              </Form.Item>
                )
              : (
              <Form.Item
              noStyle
              shouldUpdate={(pre, cur) => (pre.email !== cur.email)}
            >
              {({ getFieldValue }) => {
                const disabled = !isEmail(getFieldValue('email'))
                return (
                  <Button
                    loading={loading}
                    disabled={disabled}
                    className={forgetPassStyles.stepOneButton}
                    type="primary"
                    htmlType="submit"
                  >{I18n.t('forgetPass_step_one_next')}</Button>
                );
              }}

          </Form.Item>
                )
          }
        </Form>
      </div>
      <SafetTipModal
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        centered
      />
      <Footer className={cn('copyright', forgetPassStyles.copyright, 'DINPro')}>{I18n.t('layout_footer')}</Footer>
    </div>
  );
}

export default withRouter(Index)
